export default __webpack_public_path__ + "static/media/Chassis, White.0cb562b2.png";